export enum ProcessKpiOptInOrigin {
  LOGIN = 'login',
  OUTLET_CHANGE = 'outlet-change',
  CONFIG_CHANGE = 'config-change'
}

/**
 * Session storage key marking that the browser is reloaded because the outlet configuration was saved.
 */
export const CONFIG_CHANGE_RELOAD_MARKER: string = 'awp-config-change-reload';
